export const routes = () => [
    {
        path: `/medical-file/:patientID/:visitNO`,
        name: `medical-file.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
    {
        path: `/medical-file/:patientID/:visitNO/:encounterID`,
        name: `medical-file.encounter.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
    {
        path: `/medical-file/lab-result/print/:patientID/:labResultID`,
        name: `medical-file.lab-result.print`,
        component: () => import('./prints/InvestigationLabRequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    }
    , {
        path: `/medical-file/other-lab-result/print/:patientID/:labResultID`,
        name: `medical-file.other-lab-result.print`,
        component: () => import('./prints/OtherInvestigationLabRequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    } , {
        path: `/medical-file/other-imaging-result/print/:patientID/:labResultID`,
        name: `medical-file.other-imaging-result.print`,
        component: () => import('./prints/OtherImagingResults.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/imaging-result/print/:patientID/:labResultID`,
        name: `medical-file.imaging-result.print`,
        component: () => import('./prints/RadiologyResults.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    }, {
        path: `/medical-file/imaging-image-result/print/:patientID/:labResultID`,
        name: `medical-file.imaging-image-result.print`,
        component: () => import('./prints/RadiologyImageResults.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/imaging-requests/print/:patientID/:visitNo`,
        name: `medical-file.imaging-requests.print`,
        component: () => import('./prints/CombinedVisitRadiology.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/lab-requests/print/:patientID/:visitNo`,
        name: `medical-file.imaging-requests.print`,
        component: () => import('./prints/LabVisitRequests.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/prescriptions/print/:patientID/:visitNO`,
        name: `medical-file.prescriptions.print`,
        component: () => import('./prints/Prescriptions.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },{
        path: `/medical-file/otherprescriptions/print/:patientID/:visitNO`,
        name: `medical-file.otherprescriptions.print`,
        component: () => import('./prints/OtherPrescription.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/prescriptions-today/print/:patientID/:visitNO`,
        name: `medical-file.prescriptions-today.print`,
        component: () => import('./prints/PrescriptionToday.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/sick-off-note-print/print/:patientID/:visitNO`,
        name: `medical-file.sick-off-note-print.print`,
        component: () => import('./prints/SickOffNote.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/referral-note-print/print/:patientID/:visitNO`,
        name: `medical-file.referral-note-print.print`,
        component: () => import('./prints/ReferralNote.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/physical-exam-print/print/:patientID/:physicalExamId`,
        name: `medical-file.physical-exam-print.print`,
        component: () => import('./prints/PhysicalExam.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/combined-visit-lab-results-print/print/:patientID/:visitNo`,
        name: `medical-file.combined-visit-lab-results-print.print`,
        component: () => import('./prints/CombinedVisitInvestigations.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/lab-pending-requests/print/:patientID/:visitNo`,
        name: `medical-file.investigations-requests.print`,
        component: () => import('./prints/LabRequests.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/lab-pending-request/print/:patientID/:investigationId`,
        name: `medical-file.lab-pending-request.print`,
        component: () => import('./prints/LabRequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/imaging-pending-requests/print/:patientID/:visitNo`,
        name: `medical-file.imaging-pending-requests.print`,
        component: () => import('./prints/ImagingRequests.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/imaging-pending-request/print/:patientID/:investigationId`,
        name: `medical-file.imaging-pending-request.print`,
        component: () => import('./prints/ImagingRequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/procedures-pending/print/:patientID/:visitNo`,
        name: `medical-file.procedures-pending.print`,
        component: () => import('./prints/Procedures.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
    {
        path: `/medical-file/procedure-pending/print/:patientID/:procedureId`,
        name: `medical-file.procedure-pending.print`,
        component: () => import('./prints/Procedure.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },
];